import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { RouterModule } from '@angular/router';
import { NavHeaderModule } from './nav-header/nav-header.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FooterModule } from './footer/footer.module';
import { HttpClientModule } from '@angular/common/http';
import { WidgetRrssComponent } from './widget-rrss/widget-rrss.component';
import { LOCALE_ID } from '@angular/core';
import localeEs from '@angular/common/locales/es';
import { registerLocaleData } from '@angular/common';

registerLocaleData(localeEs);
@NgModule({
  declarations: [
    AppComponent,
    WidgetRrssComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    NavHeaderModule,
    FooterModule,
    NgbModule

  ],
  providers: [{ provide: LOCALE_ID, useValue: 'es' }],
  bootstrap: [AppComponent]
})
export class AppModule { }
